import React, {  Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';


import useRouteParams from "../../hooks/useRouteParams";
import TemplateTextFileContentView from "./TemplateTextFileContentView";
import TemplateObjectFileContentView from "./TemplateObjectFileContentView";
function TemplateFileContentView(props) {
  const {  searchParams } = useRouteParams();



  return (
    <Fragment>
      {searchParams["fileId"] ? (
        <TemplateTextFileContentView/>
      ) : searchParams["objId"] ? (
        <TemplateObjectFileContentView/> // Render this component when objId is present
      ) : (
        <></> // Render nothing if neither fileId nor objId is present
      )}
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {    
 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
 
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateFileContentView);
